import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { Combobox } from "../../../components/ui/combobox";
import { useEffect, useState } from "react";
import { boatsFetch } from "../../../lib/boatsFetch";
import { useDebounce } from "../../../lib/useDebounce";

type Marina = {
  name: string[];
  entityType: "location";
};

export const Marina = ({ defaultValue }: { defaultValue?: string }) => {
  const [marina, setMarina] = useState<Marina | null>(
    defaultValue ? { entityType: "location", name: [defaultValue] } : null,
  );

  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Marina</h3>
      <FormField<FiltersFormT, "location">
        name="location"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Combobox
                className="flex w-96"
                loadOptions={(query) => {
                  const data = boatsFetch<{ data: any[]; success: boolean }>(
                    `/search/locations?only=location${query ? `&query=${query}` : ""}`,
                  ).then((r) => r.data);
                  return data;
                }}
                placeholder="Search for marina..."
                value={marina}
                onChange={(v) => {
                  if (v && v.name[0] !== marina?.name[0]) {
                    setMarina(v);
                    field.onChange(v.name[0]);
                  } else {
                    setMarina(null);
                    field.onChange("");
                  }
                }}
                renderOption={(r) => r.name[0]}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
};
